import { React, useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import styled from 'styled-components';

import UpButtonArrowImagePath from '../../../image/UpButtonArrow.png';
import DownButtonArrowImagePath from '../../../image/DownButtonArrow.png';

const CountInput = forwardRef((props, ref) => {
  const { disabled, value, setValue } = props;

  // const [value, setValue] = useState(0);
  
  const InputRef = useRef();

  useImperativeHandle(ref, () => ({
		getValue: () => {
			return value;
		}
	}));

  // useEffect(() => {
  //   changeFn(value);
  // }, [value])

  function handleChange(e) {
    const curValue = e.target.value
		const newValue = curValue.replace(/[^0-9]/g, '')

    if (newValue < 9999999)
		  setValue(newValue);
  }

  function handleFocus() {
    InputRef.current.style.border = `1px solid #FF8B48`;
  }

  function handleBlur() {
    InputRef.current.style.border = `1px solid #DFDFDF`;
  }

  function upClick() {
    if (disabled) return;

    if (value < 9999999) setValue(parseInt(value) + 1)
    else setValue(0);
  }

  function downClick() {
    if (disabled) return;

    if (value > 0) setValue(parseInt(value) - 1)
  }

  return (
    <TopLevelWrapper>
      <LayerWrapper>
        <Title>추가 수강</Title>
        <Input 
          ref={InputRef}
          placeholder='0'
          value={value || ''}
          disabled={disabled}
          onFocus={handleFocus}
          onChange={handleChange}
          onBlur={handleBlur}/>
      </LayerWrapper>
      <LayerWrapper>
        <Text>회</Text>
      </LayerWrapper>
      <LayerWrapper>
        <ButtonWrapper>
          <Button img={UpButtonArrowImagePath} onClick={upClick}/>
          <Button img={DownButtonArrowImagePath} onClick={downClick}/>
        </ButtonWrapper>
      </LayerWrapper>
    </TopLevelWrapper>
  )
})

export default CountInput;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

`;

const LayerWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
`;

const Title = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #595959;

  margin: 0 16px 0 0;
`;

const Input = styled.input`
  width: 61px;
  height: 30px;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  margin: 0 8px 0 0;
  padding: 0 0 0 8px;

  border: 1px solid #DFDFDF;
  border-radius: 8px;
  outline: none;

  color: #CBCBCB;
  background-color: ${props => props.disabled ? '#ECECEC' : '#FFFFFF'};

  transition: all 0.3s ease-in-out;

  ::placeholder {
    color: #CBCBCB;
  }
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: #777777;

  margin: 0 8px 0 0;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
  // margin-top: 24px;
`;

const Button = styled.div`
  display: flex;
  flex-direction: column;
  
  justify-content: center;
  align-items: center;

  width: 30px;
  height: 30px;

  border: 1px solid #DFDFDF;
  border-radius: 8px;

  background: url(${props => props.img}) no-repeat center center;
  background-color: #ECECEC;

  :hover {
    cursor: pointer;
  }
`;